import Constants from 'expo-constants';

const extra = Constants.expoConfig?.extra ?? {};

const {
  API_URL,
  GRAPHQL_URL,
  MEDIA_STORAGE,
  WHATSAPP_URL,
  AMPLITUDE_API_KEY,
  DYNAMICLINK_API_KEY,
  COUNTRY_CODE,
  ENVIRONMENT,
  AI_SUPPORT_UI_URL,
  MOENGAGE_API_KEY,
  INSTABUG_KEY,
  SENTRY_WEB_KEY,
  SENTRY_MOBILE_KEY,
  MIN_STORAGE_MB,
  DOWNTIME_CHECK_URL,
  API_KEY,
  APP_API_KEY,
  SESSION_TIMEOUT_MS,
  BASE_PATH,
  APP_PACKAGE,
  AD_MOB_BANNER_ID_ANDROID,
  HOT_UPDATER_BASE_URL,
  HOT_UPDATER_CHANNEL,
} = extra;

export default {
  WHATSAPP_URL,
  API_URL,
  AMPLITUDE_API_KEY,
  GRAPHQL_URL,
  MEDIA_STORAGE,
  DYNAMICLINK_API_KEY,
  COUNTRY_CODE,
  ENVIRONMENT,
  AI_SUPPORT_UI_URL,
  MOENGAGE_API_KEY,
  INSTABUG_KEY,
  SENTRY_WEB_KEY,
  SENTRY_MOBILE_KEY,
  MIN_STORAGE_MB,
  DOWNTIME_CHECK_URL,
  API_KEY,
  APP_API_KEY,
  SESSION_TIMEOUT_MS,
  BASE_PATH,
  APP_PACKAGE,
  AD_MOB_BANNER_ID_ANDROID,
  HOT_UPDATER_BASE_URL,
  HOT_UPDATER_CHANNEL,
};
